import "./footer.scss";

const Footer = () => {
  return (
    <footer id="footer" className="footer">
      <div className="container">
        <p className="footer-details">Aliakbar Imanov &#169; {new Date().getFullYear()}</p>
      </div>
    </footer>
  );
};

export default Footer;
